module.exports = __webpack_public_path__ + "static/media/Banner-Synthetical.0dce0a9f.jpg";